import React, { useEffect } from 'react';
import { useField } from 'formik';

import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormField from '~/commons/components/FormField.jsx';
import { numToLetter } from '~/commons/helpers';

const FieldsImageDragDrop = ({
  idx,
  qtnIndex: i,
  restrictEdit = false,
  fileUploadUrl,
}) => {
  const [, { value }] = useField(`questionSets[${idx}].questions.${i}`);
  const [, , { setValue: setAns }] = useField(
    `questionSets[${idx}].questions.${i}.answers`,
  );
  const [, , { setValue: setMatches }] = useField(
    `questionSets[${idx}].questions.${i}.matches`,
  );
  let { choices } = value;
  const { answers, matches } = value;

  // take out the last empty choice
  if (!restrictEdit && !choices.slice(-1)[0]) {
    choices = choices.slice(0, -1);
  }

  useEffect(() => {
    if (
      answers.length !== choices.length
      || matches.length !== choices.length
    ) {
      // ensure right number of answers and matches
      let a = answers.slice(0, choices.length);
      const m = matches.slice(0, choices.length);

      // default missing answers to empty string (meaning '不配對') and matches to ''
      a.push(...choices.slice(a.length).map(() => ''));
      m.push(...choices.slice(m.length).map(() => ''));
      // normalize answers: keep empty-string as explicit 'no-match',
      // coerce out-of-range numeric values to the index string fallback
      a = a.map((k, ii) => {
        if (k === null) return '';
        if (String(k).trim() === '') return '';
        const n = Number(k);
        if (Number.isNaN(n) || n >= choices.length) return ii.toString();
        return String(k);
      });

      setAns(a);
      setMatches(m);
    }
  }, [choices.length, answers.length, matches.length, setAns, setMatches]);

  return (
    <div className="row">
      <div className="col">
        <label>線索 *</label>
        <FieldArrayIterables
          name={`questionSets[${idx}].questions.${i}.choices`}
          {...(restrictEdit
            ? {}
            : {
              tail: '',
            })}
        >
          {(c, ii) => (
            <div className="form-row align-items-center" key={ii}>
              <div className="col-auto pb-3">{ii + 1}.</div>
              <div className="col">
                <FormGroup
                  className="contain"
                  name={`questionSets[${idx}].questions.${i}.choices.${ii}`}
                  label="Image (suggested dimension: 1280 x 960px) / Video (mg4)"
                  as="coverImgVideo"
                  api={fileUploadUrl}
                />
              </div>
            </div>
          )}
        </FieldArrayIterables>
      </div>
      <div className="col">
        <label>配對 *</label>
        {matches.map((m, ii) => (
          <FormGroup
            key={ii}
            name={`questionSets[${idx}].questions.${i}.matches.${ii}`}
            label={null}
            prepend={
              <div className="d-flex">
                <FormField
                  name={`questionSets[${idx}].questions.${i}.answers.${ii}`}
                  as="select"
                >
                  <option value="">不配對</option>
                  {choices.map((c, iii) => (
                    <option key={iii} value={iii}>
                      {iii + 1}
                    </option>
                  ))}
                </FormField>
                <div className="d-flex align-items-center p-2">
                  {numToLetter(ii, true)}.
                </div>
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default FieldsImageDragDrop;
